import type { IssuesUpdatePayload } from '@atlassian/jira-bulk-operations-common';
import {
	isOptimisticUpdateSupported,
	transformFieldForOptimisticUpdates,
	type ListIssueField,
} from '@atlassian/jira-business-fields';
import type { BaseIssueNode } from '@atlassian/jira-business-list-handlers';

export const transformData = (existingIssue: BaseIssueNode, data: IssuesUpdatePayload['data']) => {
	const optimisticUpdateFields: ListIssueField[] = [];

	return Object.keys(data).reduce((acc, fieldId) => {
		const accumulator = acc;

		const existingField = existingIssue.fields?.find((field) => field.fieldId === fieldId);

		if (existingField && isOptimisticUpdateSupported(existingField.type)) {
			const fieldFormValue = data[existingField.fieldId];

			if (fieldFormValue === undefined) {
				return accumulator;
			}

			const transformedField = transformFieldForOptimisticUpdates(
				existingField.type,
				existingField,
				fieldFormValue,
			);

			if (transformedField !== undefined) accumulator.push(transformedField);
		}

		return accumulator;
	}, optimisticUpdateFields);
};
